import { Gender, TrendingItem } from '@/.gql/graphql';
import { TActualItem } from '@/src/providers';
import { proxyCdnUrl } from './proxyCdnUrl';

type HasGenderImages = {
  imageWoman?: string;
  imageMan?: string;
  imageWomanAndMan?: string;
  imageWomanAndWoman?: string;
  imageManAndMan?: string;
  imageManAndWoman?: string;
};

type HasGenderVideos = {
  videoWoman?: string;
  videoMan?: string;
};

type HasGenderPreviews = {
  previewWoman?: string;
  previewMan?: string;
};

type HasGenderGifs = {
  femaleGifUrl?: string;
  maleGifUrl?: string;
  femaleAndFemaleGifUrl?: string;
  femaleAndMaleGifUrl?: string;
  maleAndFemaleGifUrl?: string;
  maleAndMaleGifUrl?: string;
};

export const getImageByGender = (
  item: TActualItem | TrendingItem,
  gender: Gender,
): string | null => {
  if ('imageWoman' in item) {
    const gendered = item as Partial<HasGenderImages>;
    switch (gender) {
      case Gender.Female:
        return proxyCdnUrl(gendered.imageWoman) ?? null;
      case Gender.Male:
        return proxyCdnUrl(gendered.imageMan) ?? null;
      case Gender.FemaleAndFemale:
        return proxyCdnUrl(gendered.imageWomanAndWoman) ?? null;
      case Gender.FemaleAndMale:
        return proxyCdnUrl(gendered.imageWomanAndMan) ?? null;
      case Gender.MaleAndFemale:
        return proxyCdnUrl(gendered.imageManAndWoman) ?? null;
      case Gender.MaleAndMale:
        return proxyCdnUrl(gendered.imageManAndMan) ?? null;
      default:
        return null;
    }
  }

  if ('videoWoman' in item) {
    const gendered = item as Partial<HasGenderVideos>;

    switch (gender) {
      case Gender.Female:
        return proxyCdnUrl(gendered.videoWoman) ?? null;
      case Gender.Male:
        return proxyCdnUrl(gendered.videoMan) ?? null;
      default:
        return null;
    }
  }

  if ('previewWoman' in item) {
    const gendered = item as Partial<HasGenderPreviews>;

    switch (gender) {
      case Gender.Female:
        return proxyCdnUrl(gendered.previewWoman) ?? null;
      case Gender.Male:
        return proxyCdnUrl(gendered.previewMan) ?? null;
      default:
        return null;
    }
  }

  if ('femaleGifUrl' in item) {
    const gendered = item as Partial<HasGenderGifs>;

    switch (gender) {
      case Gender.Female:
        return proxyCdnUrl(gendered.femaleGifUrl) ?? null;
      case Gender.Male:
        return proxyCdnUrl(gendered.maleGifUrl) ?? null;
      case Gender.FemaleAndFemale:
        return proxyCdnUrl(gendered.femaleAndFemaleGifUrl) ?? null;
      case Gender.FemaleAndMale:
        return proxyCdnUrl(gendered.femaleAndMaleGifUrl) ?? null;
      case Gender.MaleAndFemale:
        return proxyCdnUrl(gendered.maleAndFemaleGifUrl) ?? null;
      case Gender.MaleAndMale:
        return proxyCdnUrl(gendered.maleAndMaleGifUrl) ?? null;

      default:
        return null;
    }
  }

  return null;
};
